module.exports = __webpack_public_path__ + "img/default-image.93fd7d12.png";